import messageService from 'services/message.service';

const state = {
    hotels: [],
    messages: [],
    messagesInfo: [],
    unreadMessagesCount: 0,
    loading: false,
    isEmptyMessages: true,
    filter: {
        claim: '',
        status: null,
        sort: null
    }
};

const mutations = {
    setRead(state, messageId) {
        state.messages.find(message => message.ChatInc == messageId).ChatIsRead = 1;
    },
    setHotels(state, hotels) {
        state.hotels = hotels;
    },
    setUnreadMessagesCount(state, unreadMessagesCount) {
        state.unreadMessagesCount = unreadMessagesCount;
    },
    setMessages(state, messages) {
        state.messages = messages;
    },
    setMessagesInfo(state, messagesInfo) {
        state.messagesInfo = messagesInfo;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setIsEmptyMessages(state, isEmpty) {
        state.isEmptyMessages = isEmpty;
    },
    addFirstMessage(state, message) {
        state.messages.unshift(message);
    }
};

const actions = {
    clearResult ({ commit }) {
        commit('setMessages', []);
    },
    getHotels({ commit }) {
        messageService.getHotels().then(hotels => {
            commit('setHotels', hotels);
        });
    },
    getUnreadMessagesCount({ commit }) {
        messageService.getUnreadMessagesCount().then(response => {
            commit('setUnreadMessagesCount', response.data[1][0].unreadcnt);
        });
    },
    getMessages({ commit }, params) {
        commit('setMessages', []);
        commit('setLoading', true);
        params['type'] = 1;
        messageService.getMessages(params).then(response => {
            const messages = response[0];
            const messagesInfo = response[1][0];

            commit('setMessages', messages);
            commit('setMessagesInfo', messagesInfo);
            commit('setIsEmptyMessages', !messages.length);
            commit('setLoading', false);
        }).catch(() => {
            commit('setLoading', false);
        });
    },
    loadMore({ commit, state }, params) {
        return new Promise((resolve, reject) => {
            messageService.getMessages(params).then(response => {
                const messages = response[0];
                const combinedMessages = state.messages.concat(messages);

                commit('setMessages', combinedMessages);
                commit('setIsEmptyMessages', combinedMessages.length === 0);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        });
    },
    sendMessage({ commit }, params) {
        params['send_type'] = 1;
        return new Promise((resolve, reject) => {
            messageService.sendMessage(params).then(() => {
                const newMessage = {
                    ChatClaim: params.claimId,
                    ChatEdate: new Date().toISOString(),
                    ChatText: params.message,
                };
                resolve(newMessage);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    setRead({ commit }, params) {
        return new Promise((resolve, reject) => {
            messageService.setRead(params).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    atFirstMessage({ commit, state }, message) {
        commit('setMessages', [message, ...state.messages]);
    }
};

const getters = {
    messages: state => state.messages,
    loading: state => state.loading,
    isEmptyMessages: state => state.isEmptyMessages,
    messagesInfo: state => state.messagesInfo
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
